import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Documento } from '../../_model/documento';

@Component({
  selector: 'app-terms-of-acceptance',
  templateUrl: './terms-of-acceptance.component.html',
  styleUrls: ['./terms-of-acceptance.component.scss']
})
export class TermsOfAcceptanceComponent implements OnInit {

  @Input() idOfField: string;
  @Input() formGroup: FormGroup;
  @Input() additionalClassInDescriptionOfTerms = 'text-light';
  @Input() additionalClassFirstSection = 'gx-0hq';
  @Input() politicaPrivacidade: Documento;

  constructor() { }

  ngOnInit(): void {
  }

  public getCampo(formGroup: FormGroup, field: string): any {
    return formGroup.controls[field];
  }

}
